import { render } from "./BottomMenu.vue?vue&type=template&id=088946be"
import script from "./BottomMenu.vue?vue&type=script&lang=js"
export * from "./BottomMenu.vue?vue&type=script&lang=js"

import "./BottomMenu.vue?vue&type=style&index=0&id=088946be&lang=css"
script.render = render

export default script